import React, { useState, useEffect } from "react";
import { FaPhone } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import endPoint from "../redux/EndPoint/endpoint";

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const navigate = useNavigate();
  const [otpData, setOtp] = useState("");

  useEffect(() => {
    const existingSessionId = localStorage.getItem("sessionId");
    if (!existingSessionId) {
      const newSessionId = uuidv4();
      localStorage.setItem("sessionId", newSessionId);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    const sessionId = localStorage.getItem("uuid");
    if (!phoneNumber || !sessionId) {
      alert("Phone number or session ID is missing.");
      return;
    }

    const payload = {
      phoneNo: phoneNumber,
      loginMethods: "PhoneNo",
      sessionId: sessionId,
    };

    const OTP = Math.floor(1000 + Math.random() * 9000);
    const otpData = {
      otp: OTP.toString(),
      phoneNumber: phoneNumber,
    };
    const apiKey =
      "LiHn8kzJMTxS3oV7Zmrv5EeuA0FRqKDaN1pQCYg6PtsdOfl9GbeznWyTmUw3HX5r9sQG2DxljIpgOfb1";
    const url = `https://www.fast2sms.com/dev/bulkV2?authorization=${apiKey}&route=dlt&sender_id=GWSCOD&message=169486&variables_values=${OTP}&flash=0&numbers=${encodeURIComponent(
      phoneNumber
    )}`;
    try {
      const resOtp = await fetch(url, { method: "GET" });
      const res = await fetch(endPoint.LOGIN, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (resOtp.ok) {
        if (result.token) {
          localStorage.setItem("authToken", result.token);
        }
        if (result.user && result.user._id) {
          localStorage.setItem("userId", result.user._id);
        }
        if (result.orderID) {
          localStorage.setItem("orderID", result.orderID);
        }

        const storedCheckoutData = localStorage.getItem("checkoutData");
        if (storedCheckoutData) {
        } else {
          console.log("No checkout data found in localStorage after login.");
        }
        toast.success("Otp Send Success!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
        navigate("/OtpScreen", { state: { otpData } });
      } else {
        alert("Login failed.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br sm:from-pink-50 via-blue-200 to-white py-10">
      <form
        onSubmit={handleLogin}
        className="bg-white rounded-2xl shadow-lg max-w-md p-8 space-y-8 sm:w-full w-[90%]"
      >
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-800">Welcome Back!</h2>
          <p className="text-gray-600 mt-2">Please sign in to continue</p>
        </div>

        <div className="relative">
          <FaPhone className="absolute top-3 left-3 text-gray-400" />
          <input
            type="tel"
            placeholder="Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full py-2 px-4 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700"
        >
          Login
        </button>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            Don't have an account?{" "}
            <a href="/Register" className="text-indigo-600 hover:underline">
              Sign up
            </a>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Login;
